module.exports = __webpack_public_path__ + "img/BUCK-SLIDER-03.60213ca3.jpg";